"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceDotsWithCommas = exports.renderDDMMYYYY = exports.removeNonDigits = exports.removeCommaWhitespace = exports.mergeFunction = exports.fullfillTime = exports.fullfillDate = exports.CompressList = exports.SimpleList = exports.scanPropsAsync = exports.scanProps = exports.getRegi = exports.currentWeek = exports.isSetAndTrue = exports.isSet = exports.blankToNull = exports.zeroToNull = exports.nullAndZeroToFalse = exports.nullToHtmlBlank = exports.nullToBlank = exports.nullToZero = exports.undefinedToNull = exports.isDefined = undefined;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _config = require("../../../server/src/config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _bluebird2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _bluebird2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

const isDefined = exports.isDefined = val => typeof val !== 'undefined';
const undefinedToNull = exports.undefinedToNull = val => typeof val === 'undefined' ? null : val;
const nullToZero = exports.nullToZero = val => val === null ? 0 : val;
const nullToBlank = exports.nullToBlank = val => val === null ? '' : val;
const nullToHtmlBlank = exports.nullToHtmlBlank = val => val === null ? _react2.default.createElement(
    "span",
    null,
    "\xA0"
) : val;
const nullAndZeroToFalse = exports.nullAndZeroToFalse = val => val !== null && val !== 0;
const zeroToNull = exports.zeroToNull = val => val === 0 ? null : val;
const blankToNull = exports.blankToNull = val => val === '' ? null : val;
const isSet = exports.isSet = (obj, prop) => typeof obj[prop] !== 'undefined';
const isSetAndTrue = exports.isSetAndTrue = prop => typeof prop !== 'undefined' && prop;

const currentWeek = exports.currentWeek = () => {
    const now = new Date();
    const week = (0, _moment2.default)(now).isoWeekday() > 3 ? (0, _moment2.default)(now).isoWeek() : (0, _moment2.default)(now).isoWeek() - 1;
    return week;
};

const getRegi = exports.getRegi = kfk => {
    if (!/^[0-9]{2}/.test(kfk)) return null;
    if (kfk >= '97' || kfk < '88') return 'Privat';
    if (kfk >= '95' && kfk < '97') return 'Sektion';
    return 'DdB';
};

// Scan all properties with a specified prefix of an object.
const scanProps = exports.scanProps = (obj, prefix, cb) => {
    for (const propName in obj) {
        if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) cb(obj[propName], propName);
    }
};
const scanPropsAsync = exports.scanPropsAsync = (() => {
    var _ref = _asyncToGenerator(function* (obj, prefix, cb) {
        const props = [];
        for (const propName in obj) {
            if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) props.push({
                name: propName,
                value: obj[propName]
            });
        }
        yield _bluebird2.default.all(props.map((() => {
            var _ref2 = _asyncToGenerator(function* (prop) {
                yield cb(prop.value, prop.name);
            });

            return function (_x4) {
                return _ref2.apply(this, arguments);
            };
        })()));
    });

    return function scanPropsAsync(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
})();

// Create a simple list of numbers (n1-nx replaced n1, n2... nx) from a compressed list.
const SimpleList = exports.SimpleList = (txt, allowDuplicates = true, validateItem = null, allowRanges = true) => {
    const result = [];
    let isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        const items = txt.split(',');
        items.forEach(item => {
            const endPoints = item.split('-');
            switch (endPoints.length) {
                case 1:
                    const n = item.trim();
                    if (/^[0-9]+$/.test(n)) {
                        if (!allowDuplicates && result.indexOf(n) >= 0) isErrors = true;else if (validateItem !== null && !validateItem(n)) isErrors = true;else result.push(n);
                    } else isErrors = true;
                    break;
                case 2:
                    if (allowRanges) {
                        const n1 = endPoints[0].trim();
                        const n2 = endPoints[1].trim();
                        if (/^[0-9]+$/.test(n1) && /^[0-9]+$/.test(n2)) {
                            if (Number(n1) > Number(n2)) isErrors = true;else for (let n = Number(n1); n <= Number(n2); n++) {
                                if (!allowDuplicates && result.indexOf(String(n)) >= 0) isErrors = true;else if (validateItem !== null && !validateItem(String(n))) isErrors = true;else result.push(String(n));
                            }
                        } else isErrors = true;
                    } else isErrors = true;
                    break;
                default:
                    isErrors = true;
            }
        });
    }
    return {
        items: result.sort((n1, n2) => Number(n1) - Number(n2)),
        isErrors: isErrors
    };
};

// Create a compressed list (n1, n2... nx replaced by n1-nx) from a simple list of numbers.
const CompressList = exports.CompressList = txt => {
    const result = [];
    let isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        const items = txt.split(',').map(item => item.trim());
        if (items.findIndex(item => !/^[0-9]+$/.test(item)) >= 0) isErrors = true;else {
            let n1 = null;
            items.sort((n1, n2) => Number(n1) - Number(n2)).filter((item, ix, items) => ix === 0 || items[ix] !== items[ix - 1]).forEach((item, ix) => {
                const n = Number(item);
                if (ix === 0 || n !== Number(items[ix - 1]) + 1) n1 = n;
                if (ix === items.length - 1 || n !== Number(items[ix + 1]) - 1) {
                    if (n1 === n) result.push(String(n));else result.push(String(n1) + '-' + String(n));
                }
            });
        }
    }
    return {
        items: result,
        isErrors: isErrors
    };
};

// Fullfill date entry.
const fullfillDate = exports.fullfillDate = txt => {
    if (txt === null || txt === '') return txt;
    const now = new Date();
    const yr = String(now.getFullYear());
    let d = '';
    let m = '';
    let y = '';
    if (txt.indexOf('-') >= 0) {
        const parts = txt.split('-');
        d = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        y = parts.length > 2 ? parts[2].trim() : '';
    } else {
        const trimTxt = txt.trim();
        if (/^[0-9]{2}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 1);
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 2);
        } else if (/^[0-9]{7}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 4);
        } else if (/^[0-9]{8}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 4);
        }
    }
    if (/^[0-9]{1}$/.test(d)) d = '0' + d;
    if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (y === '') y = yr;else if (/^[0-9]{2}$/.test(y)) y = yr.substr(0, 2) + y;
    if (!/^[0-9]{2}$/.test(d) || !/^[0-9]{2}$/.test(m) || !/^[0-9]{4}$/.test(y)) return 'error';
    if (!(0, _moment2.default)(d + '-' + m + '-' + y, _config2.default.formats.dateFormat, true).isValid()) return 'error';
    return d + '-' + m + '-' + y;
};

// Fullfill time entry.
const fullfillTime = exports.fullfillTime = (txt, includeSeconds = false) => {
    if (txt === null || txt === '') return txt;
    let h = '';
    let m = '';
    let s = '';
    if (txt.indexOf(':') >= 0) {
        const parts = txt.split(':');
        h = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        s = parts.length > 2 ? parts[2].trim() : '';
    } else {
        const trimTxt = txt.trim();
        if (/^[0-9]{1}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{2}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
            s = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            s = trimTxt.substr(4, 2);
        }
    }
    if (/^[0-9]{1}$/.test(h)) h = '0' + h;
    if (m === '') m = '00';else if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (s === '') s = '00';else if (/^[0-9]{1}$/.test(s)) s = '0' + s;
    if (!/^([0-1][0-9]|20|21|22|23)$/.test(h) || !/^[0-5][0-9]$/.test(m) || !/^[0-5][0-9]$/.test(s)) return 'error';
    return includeSeconds ? h + ':' + m + ':' + s : h + ':' + m;
};

// Default reducer merge function to combine original entity with new properties read or updated from database.
const mergeFunction = exports.mergeFunction = (original, updated) => {
    const result = Object.assign({}, original);
    for (var prop in updated) {
        if (updated.hasOwnProperty(prop)) {
            result[prop] = updated[prop];
        }
    }
    return result;
};

const removeCommaWhitespace = exports.removeCommaWhitespace = string => {
    // removing all white space between a comma and any letter
    return string.replace(/\s*,\s*/g, ",");
};

const removeNonDigits = exports.removeNonDigits = string => {
    return string.replace(/\D/g, '');
};

const renderDDMMYYYY = exports.renderDDMMYYYY = date => {
    if (date === null) return null;
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return `${da}-${mo}-${ye}`;
};

const replaceDotsWithCommas = exports.replaceDotsWithCommas = float => {
    return float.toString().replace('.', ',');
};


// WEBPACK FOOTER //
// ./build-server/common/src/util/lib.js